var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 13.4167V27.6317C30 28.2314 29.736 28.8256 29.2336 29.2778C28.7285 29.7324 28.0272 30 27.2807 30H2.7193C1.97281 30 1.27147 29.7324 0.76634 29.2778C0.263954 28.8256 0 28.2314 0 27.6317V13.4239C0.000634319 13.3323 0.0212413 13.2393 0.0634807 13.1493C0.106092 13.0585 0.17103 12.9705 0.259097 12.8928L0.26496 12.8876L14.2983 0.258035C14.4744 0.100855 14.7291 0 15.0088 0C15.2885 0 15.5425 0.100228 15.7185 0.257408L29.7502 12.8854L29.7512 12.8863C29.8367 12.9641 29.8995 13.0518 29.9403 13.1419C29.9812 13.232 30.0006 13.3251 30 13.4167ZM10.7017 28.4212H19.2982V20.4478C19.2982 19.6194 18.6267 18.9478 17.7982 18.9478H12.2017C11.3733 18.9478 10.7017 19.6194 10.7017 20.4478V28.4212ZM1.92982 13.7175V26.9212C1.92982 27.7496 2.6014 28.4212 3.42982 28.4212H8.77193V19.7373C8.77193 19.1376 9.03588 18.5434 9.53827 18.0912C10.0434 17.6366 10.7447 17.369 11.4912 17.369H18.5088C19.2553 17.369 19.9566 17.6366 20.4617 18.0912C20.9641 18.5434 21.2281 19.1376 21.2281 19.7373V28.4212H26.5702C27.3986 28.4212 28.0702 27.7496 28.0702 26.9212V13.7175L15 1.95478L1.92982 13.7175Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5b616aa8fc1bf4c37f2ade447c45821f.svg";
export { ForwardRef as ReactComponent };